import { HighContrastSelector } from '../../Styling';
export var getStyles = function (props) {
    var className = props.className;
    var AboveAndBelowStyles = {
        position: 'absolute',
        pointerEvents: 'auto',
        width: '100%',
        zIndex: 1
    };
    return ({
        root: [
            'ms-ScrollablePane',
            {
                overflowY: 'auto',
                maxHeight: 'inherit',
                height: 'inherit',
                WebkitOverflowScrolling: 'touch'
            },
            className
        ],
        stickyAbove: [
            {
                top: 0,
                selectors: (_a = {},
                    _a[HighContrastSelector] = {
                        borderBottom: '1px solid WindowText'
                    },
                    _a)
            },
            AboveAndBelowStyles
        ],
        stickyBelow: [
            {
                bottom: 0,
                selectors: (_b = {},
                    _b[HighContrastSelector] = {
                        borderTop: '1px solid WindowText'
                    },
                    _b)
            },
            AboveAndBelowStyles
        ]
    });
    var _a, _b;
};
//# sourceMappingURL=ScrollablePane.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib-es2015/components/ScrollablePane/ScrollablePane.styles.js
// module id = 850
// module chunks = 0